<template>
  <div>
    <div class="page-top">
      <div class="container">
        <div class="row gx-4 gx-lg-5 justify-content-center">
          <div class="col-lg-8 col-xl-8 text-center">
            <h2 class="mt-0 mb-5 list-main-title">
              アフィリエイト無料登録
            </h2>
            <p class="text-silence mb-3">
              登録情報を頂いた後、アフィリエイトチームよりメールにてご案内させていただきます。通常は2営業日(月～金)以内に連絡いたしますので、重複申請はお控え頂けますようよろしくお願い致します。
              <br>ご不明な点がございましたら、下記担当までお気軽にお問い合わせください。
            </p>
            <p>&#40;受付時間 平日10&#8758;00〜18&#8758;00&#41;</p>
            <!--SNS ICON-->
            <a
              href="mailto:affiliates@katsuwin.ai"
              target="_blank"
            ><img
              class="snsicon mx-2"
              src="@/assets/theme_gold/images/icon_email.png"
            ></a>
            <a
              href="https://twitter.com/katsuwinonline"
              target="_blank"
            ><img
              class="snsicon mx-2"
              src="@/assets/theme_gold/images/icon_twitter.png"
            ></a>
            <a
              href="https://www.youtube.com/@Katsuwinonline"
              target="_blank"
            ><img
              class="snsicon mx-2"
              src="@/assets/theme_gold/images/icon_youtube.png"
            ></a>
            <a
              href="https://www.instagram.com/katsuwinonline/"
              target="_blank"
            ><img
              class="snsicon mx-2"
              src="@/assets/theme_gold/images/icon_ig.png"
            ></a>
          </div>
        </div>

        <div class="col-lg-6 col-md-9 mx-auto rounded pt-4">
          <form class="form-style">
            <div class="mb-3">
              <div class="mb-3">
                <label for="name" class="form-label ms-3">氏名</label>
                <input
                  id="name"
                  v-model="postForm.firstName"
                  class="form-control"
                  aria-describedby="nameHelp"
                  placeholder="ご登録のお名前を入力してください"
                  @input="checkField('firstName')"
                >
                <div v-show="showFieldError('firstName')" id="nameHelp" class="form-text mb-3 text-danger">
                  入力項目は空白にできません
                </div>
              </div>
              <!-- name -->

              <div class="mb-3">
                <label for="account" class="form-label ms-3">アカウント</label>
                <input
                  id="account"
                  v-model="postForm.account"
                  type="text"
                  class="form-control"
                  aria-describedby="accountHelp"
                  placeholder="ご登録のお名前を入力してください"
                  @input="checkField('account')"
                >
                <div v-show="showFieldError('account')" id="accountHelp" class="form-text mb-3 text-danger">
                  入力項目は空白にできません
                </div>
              </div>
              <!-- account -->

              <div class="mb-3">
                <label for="Email" class="form-label ms-3">メールアドレス</label>
                <input
                  id="Email"
                  v-model="postForm.email"
                  type="email"
                  class="form-control"
                  aria-describedby="EmailHelp"
                  placeholder="ご登録のメールアドレスを入力してください"
                  @input="checkField('email')"
                >
                <div v-show="showFieldError('email')" id="EmailHelp" class="form-text mb-3 text-danger">
                  入力項目は空白にできません
                </div>
              </div>
              <!-- eMail -->

              <div class="mb-3">
                <label for="phoneNumber" class="form-label ms-3">携帯番号</label>
                <input
                  id="phoneNumber"
                  v-model="postForm.phoneNumber"
                  type="number"
                  class="form-control"
                  aria-describedby="phoneNumberHelp"
                  placeholder="ご登録の携帯番号を入力してください"
                  @input="checkField('phoneNumber')"
                >
                <div v-show="showFieldError('phoneNumber')" id="phoneNumberHelp" class="form-text mb-3 text-danger">
                  入力項目は空白にできません
                </div>
              </div>
              <!-- phoneNumber -->

              <div class="mb-3">
                <label for="internetUrl" class="form-label ms-3">サイトURL</label>
                <input
                  id="internetUrl"
                  v-model="postForm.siteUrl"
                  type="text"
                  class="form-control"
                  aria-describedby="internetUrlHelp"
                  placeholder="http://"
                  @input="checkField('siteUrl')"
                >
                <div id="internetUrlHelp" class="form-text mb-3">
                  <!-- サイトURL -->※宣伝URLがない場合は、紹介方法をご入力ください
                </div>
                <div v-show="showFieldError('siteUrl')" id="internetUrlHelp" class="form-text mb-3 text-danger">
                  入力項目は空白にできません
                </div>
              </div>

              <!-- URL link text -->
            </div>
            <div class="my-5 form-check">
              <input id="exampleCheck1" v-model="isChecked" type="checkbox" class="form-check-input">
              <label
                class="form-check-label"
                for="exampleCheck1"
              ><a class="links" @click="goCondition">利用規約</a>に同意する</label>
            </div>

            <div class="d-grid">
              <button
                class="btn btn-primary btn-golden"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                :disabled="!isFormValid"
                @click="submitEmail"
              >
                登録
              </button>
            </div>
            <!-- Modal -->
            <div
              id="exampleModal"
              class="modal fade"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5
                      id="exampleModalLabel"
                      class="modal-title"
                    >
                      勝win
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    />
                  </div>
                  <div class="modal-body my-5 text-center">
                    <p>
                      情報の受付を完了いたしました。<br>
                      当サイトからの連絡をお待ちくださいませ。
                    </p>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary btn-golden"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <!-- <button type="button" class="btn btn-primary btn-golden"> changes</button> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- Modal End -->
          </form>
          <!-- form End -->
          <div id="form_alerts" class="mt-3" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProxyEmail } from '@/api/event'

export default {
  data() {
    const postForm = {
      firstName: null,
      account: null,
      email: null,
      phoneNumber: null,
      siteUrl: null
    }
    return {
      postForm,
      mailVer: process.env.VUE_APP_MAIL_VER,
      mailAddress: process.env.VUE_APP_ENV === 'production' ? 'prod' : process.env.VUE_APP_TEST_MAIL,
      testMail: '',
      GASUrl: '',
      isChecked: false,
      initialValues: {},
      fieldErrors: {}

    }
  },
  computed: {
    isFormValid() {
      return (
        this.postForm.firstName &&
        this.postForm.account &&
        this.postForm.email &&
        this.postForm.phoneNumber &&
        this.postForm.siteUrl && this.isChecked
      )
    }
  },
  created() {
    this.initialValues = JSON.parse(JSON.stringify(this.postForm))
  },
  methods: {
    checkField(field) {
      // Check if the input field is empty and the value has been modified
      this.$set(this.fieldErrors, field, this.postForm[field] === '' && this.postForm[field] !== this.initialValues[field])
    },
    showFieldError(field) {
      return this.fieldErrors[field]
    },
    goCondition() {
      this.$store.commit('SET_CONDITION_OPEN', true)
      this.$store.commit('SET_FAQ_OPEN', false)
      this.$store.commit('SET_PROXY_OPEN', false)
    },
    async submitEmail() {
      const messageData = `1.氏名：${this.postForm.firstName};;2.アカウント：${this.postForm.account};;3.メールアドレス：${this.postForm.email};;4.携帯番号：${this.postForm.phoneNumber};;5.サイトURL：${this.postForm.siteUrl}`
      const encodedMessage = encodeURIComponent(messageData)
      await new Promise((resolve) => {
        setTimeout(() => {
          this.GASUrl = 'https://script.google.com/macros/s/' + this.mailVer + '/exec?subject=' + encodeURIComponent('アフィリエイト無料登録') + '&env=' + this.mailAddress + '&message=' + encodedMessage
          resolve()
        }, 30)
      })
      getProxyEmail(this.GASUrl)
      this.postForm = {}
    }
  }
}
</script>
